<div class="container-fluid my-5">
    <div class="row" *ngIf="!loading">
        <div class="col-md-12">
            <div class="card bg-secondary shadow p-3">
                <div class="card-header bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-md-12 text-lg-left">
                            <h3 class="mb-0">Détails réservation #{{ reservation.id }}</h3>
                        </div>
                        <div class="col-md-12 text-lg-right mt-2">
                            <button type="button" class="btn btn-dark" (click)="back()">
                                <i class="fa fa-angle-left" style="margin: 0 !important;"></i>
                                <span class="d-none d-lg-inline-block" style="margin-left: 0.5rem;">Retour</span>
                            </button>
                            <button type="button" class="btn btn-success" (click)="accept()"
                                *ngIf="reservation.show_button_accpet">
                                <i class="fa fa-check" style="margin: 0 !important;"></i>
                                <span class="d-none d-lg-inline-block" style="margin-left: 0.5rem;">Accepter</span>
                            </button>
                            <button type="button" class="btn btn-danger" (click)="cancel()"
                                *ngIf="reservation.show_button_cancel">
                                <i class="fa-lg ni ni-fat-remove" style="margin: 0 !important;"></i>
                                <span class="d-none d-lg-inline-block" style="margin-left: 0.5rem;">Annuler</span>
                            </button>

                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <table class="table table-bordered">
                        <tr>
                            <td><strong>Nom et prénom : </strong></td>
                            <td>{{ reservation.artist.full_name }}</td>
                        </tr>
                        <tr>
                            <td><strong>Téléphone : </strong></td>
                            <td>{{ reservation.artist.country_code_phone }}{{ reservation.artist.phone }}
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Mail : </strong></td>
                            <td>{{ reservation.artist.email }}</td>
                        </tr>
                        <tr>
                            <td><strong>Studio : </strong></td>
                            <td>{{ reservation.studio.private_name }}</td>
                        </tr>
                        <tr>
                            <td><strong>Date de début : </strong></td>
                            <td>{{ date_format(reservation.start_date) }}</td>
                        </tr>
                        <tr>
                            <td><strong>Date de fin : </strong></td>
                            <td>{{ date_format(reservation.end_date) }}</td>
                        </tr>
                        <tr>
                            <td><strong>Nombre d'heures : </strong></td>
                            <td>{{ reservation.horaires.length }}H</td>
                        </tr>
                        <tr>
                            <td><strong>Status : </strong></td>
                            <td>
                                <span class="{{ status[reservation.status]['class']}}">{{
                                    status[reservation.status]['text']}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Montant payé par le client : </strong></td>
                            <td>{{ reservation.pay }}€</td>
                        </tr>
                        <tr>
                            <td><strong>Montant versé au studio : </strong></td>
                            <td>{{ reservation.studio_total }}€</td>
                        </tr>
                        <tr>
                            <td><strong>Date de création : </strong></td>
                            <td>{{ date_format(reservation.createdAt) }}</td>
                        </tr>
                        <tr>
                            <td><strong>Description : </strong></td>
                            <td>{{ reservation.description }}</td>
                        </tr>

                    </table>
                </div>

            </div>

        </div>

    </div>
</div>